var escape = require("../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preview_page[data-v-46b4a6ae]{padding:15px 0;background-color:#f3f7fa}.ipX_wrap[data-v-46b4a6ae],.ip7_wrap[data-v-46b4a6ae]{width:450px;height:878px;background-repeat:no-repeat}.ipX_wrap[data-v-46b4a6ae]{padding:21px 37px 127px;background-image:url(" + escape(require("../../../../assets/images/iphoneX-bg.jpg")) + ")}.ipX_wrap[data-v-46b4a6ae] .m_content{border-radius:30px 40px 0 0}.ip7_wrap[data-v-46b4a6ae]{padding:105px 42px 156px 32px;background-image:url(" + escape(require("../../../../assets/images/iphone7-bg.jpg")) + ")}\n", ""]);

// exports
